import { useState } from "react";
import { Collapse } from "react-bootstrap";

import type { EditOrderData } from "@admin/domain/orders/dto/EditOrderData";
import { registerInAnalyticalDb, removeInAnalyticalDb } from "@admin/domain/orders/api";
import { useLoaderContext } from "@admin/components/LoaderContext";
import { useOrderHooks } from "@admin/pages/OrderEditor/hooks";
import JsonView from "@admin/pages/OrderEditor/JsonView";

type Props = {
    order: EditOrderData;
};

export default function AnalyticalDb({ order }: Props) {
    const [analyticalDbDataIsCollapsed, setAnalyticalDbDataIsCollapsed] = useState<boolean>(false);

    const { isLoading } = useLoaderContext();
    const { orderRequest } = useOrderHooks();

    const sendRegisterOrderInAB = (): void => {
        orderRequest(async (): Promise<null> => await registerInAnalyticalDb(order.id));
    };

    const sendRemoveOrderInAB = (): void => {
        if (confirm(`Вы уверены, что хотите удалить заказ из аналитической БД?`)) {
            orderRequest(async (): Promise<void> => {
                const response = await removeInAnalyticalDb(order.id);

                if (response?.warnings?.length) {
                    alert(
                        response.warnings
                            .map((w: any) => w.message || `Есть предупреждение`)
                            .join(`\n`),
                    );
                }
            });
        }
    };

    return (
        <>
            <h4 className="mb-5 mt-5">Синхронизация с АБ</h4>
            <p>
                Статус заказа:
                {order.is_available_in_ab === null
                    ? `не удалось проверить наличие в Аналитической базе`
                    : order.is_available_in_ab
                      ? `есть в Аналитической базе`
                      : `отсутствует в Аналитической базе`}
            </p>

            {order.analytical_db_data ? (
                <div className="border rounded p-5 mb-3">
                    <div
                        className="cursor-pointer"
                        onClick={(): void => setAnalyticalDbDataIsCollapsed(!analyticalDbDataIsCollapsed)}
                    >
                        Лог выгрузки заказа в АБ. Id = {order.id_from_ab}
                    </div>
                    <Collapse in={analyticalDbDataIsCollapsed}>
                        <div className="mb-5">
                            <p>Данные заказа, переданные в Аналитическую базу</p>
                            <JsonView data={order.analytical_db_data} />
                        </div>
                    </Collapse>
                </div>
            ) : (
                <p>Нет сохранённых данных выгрузки заказа в Аналитическую базу</p>
            )}
            {order.is_available_in_ab ? (
                <button type="button" className="btn btn-danger" onClick={sendRemoveOrderInAB} disabled={isLoading}>
                    Удалить в АБ
                </button>                
            ) : (
                <button
                    type="button"
                    className="btn btn-info"
                    onClick={sendRegisterOrderInAB}
                    disabled={isLoading || order.is_available_in_ab === null}
                >
                    Отправить в АБ
                </button>                
            )}
        </>
    );
}
